module.exports = __webpack_public_path__ + "static/media/bussitre.a5cc7278.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/bussitre.mp4
// module id = 141
// module chunks = 0